module.exports = __webpack_public_path__ + "static/img/act01.47ed8f2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/v2/act01.jpeg
// module id = FykN
// module chunks = 76